<div class="modal-content w-100 h-100 d-flex flex-column">
  <div class="section-title apm-text-red text-break">{{ resourceIds.bulkPublishTitle | apmTranslate }}</div>
  <hr class="gray-divider-1 mb-3" />
  <apm-search-box
    class="mb-3 w-100"
    [placeholder]="(resourceIds.searchByName | apmTranslate) ?? ''"
    (searchedText)="onSearchChanged($event)"
    (cleared)="onSearchChanged(null)"
  ></apm-search-box>
  @if (rows().length === 0) {
    <div class="text-center text-muted py-5">{{ resourceIds.noDrafts | apmTranslate }}</div>
  } @else {
    <div class="bulk-publish-table w-100 position-relative">
      <apm-table
        [getRowId]="getRowId"
        [showRemoveFilter]="false"
        [rowData]="rows()"
        [columnDefs]="columnDefs"
        [suppressRowTransform]="true"
        [autoGroupColumnDef]="autoGroupColumnDef"
        [customGridOptions]="customGridOptions"
        rowSelection="multiple"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      ></apm-table>
    </div>
  }
  <div class="d-flex flex-row justify-content-between mt-auto pt-3">
    <apm-button variant="secondary" (click)="cancel()" additionalClass="px-5">
      {{ resourceIds.cancel | apmTranslate }}
    </apm-button>
    <apm-button
      variant="primary"
      [disabled]="selectedLeafCount() === 0"
      (click)="publish()"
      additionalClass="px-5"
    >
      {{ resourceIds.bulkPublishConfirm | apmTranslate: [selectedLeafCount()] }}
    </apm-button>
  </div>
</div>
